export default __webpack_public_path__ + "static/media/registration-1.3d6d4cab.png";